import { createTheme } from '@material-ui/core/styles';
import { overrides } from './overrides';
import { palette } from './palette';
import { props } from './props';
import { typography } from './typography';

const theme = createTheme({
  ...typography,
  ...palette,
  ...overrides,
  ...props,
});

export default theme;
